<template>
  <div
    ref="main"
    class="main-box"
  >
    <form-header
      v-if="datasReady"
      :form-name="formName"
      :is-submitting="isSubmitting"
      @save="handleSave"
      @back="back"
    />
    <div class="form-content">
      <div class="form-c-inner">
        <a-form
          layout="inline"
          :form="form"
        >
          <a-tabs
            default-active-key="1"
            :animated="false"
            @change="callback"
          >
            <a-tab-pane
              key="1"
              :tab="formTit"
            >
              <un-form />
            </a-tab-pane>
            <a-tab-pane
              key="2"
              force-render
            >
              <span slot="tab">
                <i
                  v-if="configFormError"
                  class="iconfont iconicon-test34 tab-error-icon"
                />
                {{ $t('message["695"]') }}
              </span>
              <div class="config-form-box">
                <config-form
                  v-if="permissions && Object.keys(permissions).length"
                  ref="configForm"
                  :permissions="permissions"
                />
              </div>
            </a-tab-pane>
            <a-tab-pane
              key="3"
              :tab="styleTit"
            >
              <view-style
                v-if="isViewShow"
                @getCustom="getCustom"
              />
              <custom-style
                v-else
                @cancelCustom="getCustom"
                @applyCustom="getCustom"
              />
            </a-tab-pane>
          </a-tabs>
        </a-form>
        <config-success-modal
          ref="successModal"
          :save-result="saveResult"
        />
        <leave-tip-dialog
          ref="leaveTip"
          @leavelHandler="leavelHandler"
        >
          <div slot="tip-slot">
            {{ $t('message["158"]') }}，<br>
            {{ $t('message["919"]') }}？
          </div>
        </leave-tip-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import FormHeader from '@/components/pc/universalForm/FormHeader'
import UnForm from './Form'
import ViewStyle from './ViewStyle'
import CustomStyle from './CustomStyle'
import ConfigForm from '../outsideForm/ConfigForm'
import ConfigSuccessModal from './ConfigSuccess'
import { mapActions, mapState, mapMutations } from 'vuex'
import { convertStyle, appendStyle } from '@/store/universalForm/convert'
import LeaveTipDialog from '@/components/pc/LeaveTipDialog'
const initData = [
  {
    listStyle: 1 // 排列，1单行，2文本输入框两行
  },
  {
    // 输入和下拉框
    inputAndSelect: {
      unit: 1, // 宽度单位 1%,2px
      width: 320, // 宽度
      height: 32, // 高度
      borderStyle: 1, // 边框样式 1四周边框 2底部边框
      borderRadius: 4, // 圆角 单位px
      backgroundColor: '#fff', // 北京色
      hoverBorderColor: '#EBEBEB', // 鼠标划过边框色
      paddingLeftAndRight: 4 // 左右内边距
    }
  },
  {
    // 文字节点
    font: {
      fontFamily: 1, // 字体 {"1":"Arial","2":"Courier","3":"Georgia","4":"Helvetica","5":"MicroSoft YaHei","6":"PingFang SC","7":"Tahoma","8":"Verdana","9":"宋体","10":"黑体"}
      contentSize: 14, // 字号
      contentColor: '#000000'// 文字颜色
    }
  },
  {
    // 按钮
    button: {
      float: 1, // 对其方式 1左对齐 2居中对齐 3右对齐
      fontSize: 16, // 按钮字号
      fontColor: '#ffffff', // 按钮字体颜色
      buttonColor: '#4CA0F2' // 按钮颜色
    }
  },
  {
    applyCustomCss: true // 是否应用自定义样式文件
  }
]
export default {
  components: {
    FormHeader,
    UnForm,
    ViewStyle,
    CustomStyle,
    ConfigForm,
    ConfigSuccessModal,
    LeaveTipDialog
  },
  data () {
    return {
      isViewShow: true,
      saveResult: '',
      count: 0,
      leave: {},
      status: false,
      hasSumbit: false,
      isSubmitting: false
    }
  },
  computed: {
    ...mapState('universalForm/form', ['payloadDatas', 'formName', 'styleDatas', 'formDefaultDatas', 'datasReady']),
    ...mapState('universalForm/outform', ['formData', 'confrimConfig', 'configFormError', 'compareFieldError', 'result', 'permissions']),
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    },
    formid () {
      return this.$route.query.formid
    },
    type () {
      return this.$route.query.type
    },
    styleTit () {
      return this.$t('message["1434"]')
    },
    formTit () {
      return this.$t('message["53"]')
    }
  },
  provide () {
    return {
      myForm: this
    }
  },
  watch: {
    payloadDatas: {
      handler (val) {
        if (val) {
          this.count++
          if (this.count > 1 && !this.hasSumbit) {
            this.removeClick()
            this.addClick()
          } else {
            this.removeClick()
          }
        }
      },
      deep: true
    },
    hasSumbit (val) {
      if (val) {
        this.removeClick()
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // this.removeClick()
    if (this.count > 1 && !this.hasSumbit) {
      if (this.status) {
        this.removeClick()
        next()
        return
      }
      this.$refs.leaveTip.changeLimitDialog(true)
      this.leave = to
      next(false)
    } else {
      this.removeClick()
      next()
    }
  },
  created () {
    this.form = this.$form.createForm(this)
    this.setConfigFormError(false)
  },
  async mounted () {
    // this.$store.commit('setPid', this.pid, { root: true })
    const chain = await this.getFormDatas()
    chain.params({ formid: this.formid, type: this.type })
      .onSuccess(() => {
        if (this.styleDatas.view_json.length === 0) {
          this.styleDatas.view_json = initData
        }
        const cssStyle = convertStyle(this.styleDatas.view_json)
        this.styleDatas.view_css = cssStyle
        appendStyle(cssStyle, 'view-css')
        this.SET_FORM_DATA(this.payloadDatas)
        this.setFromOtherOptions()
      })
      .fetch()

    this.getUniversalPermissions()
    // this.$nextTick(() => {
    //   let $main = this.$refs.main
    //   getH($main, 0)
    // })
  },
  methods: {
    ...mapActions('universalForm/form', ['getFormDatas', 'universalFormSave', 'removeClick', 'addClick']),
    ...mapActions('universalForm/outform', ['getUniversalPermissions']),
    ...mapMutations('universalForm/outform', ['SET_FORM_DATA', 'setFromOtherOptions', 'setConfigFormError']),
    callback (key) {
      // console.log(key)
    },
    getCustom () {
      this.isViewShow = !this.isViewShow
    },
    async handleSave (formname) {
      await (this.$refs.configForm && this.$refs.configForm.handleSubmit())
      this.payloadDatas.name = formname
      this.payloadDatas.config = this.formDefaultDatas
      this.payloadDatas.deploy.config = this.confrimConfig
      setTimeout(async () => {
        if (!this.configFormError) {
          this.isSubmitting = true
          const chain = await this.universalFormSave()
          chain.params(this.payloadDatas)
            .onSuccess(res => {
              this.$refs.successModal && this.$refs.successModal.showModal()
              this.saveResult = res.content
              this.hasSumbit = true
              const iframe = document.createElement('iframe')
              iframe.src = res.u
              iframe.id = 'iframe'
              if (document.getElementById('iframe')) {
                document.getElementById('iframe').src = res.u
              } else {
                document.body.appendChild(iframe)
              }
            })
            .onNetSuccess(raw => {
              this.isSubmitting = false
            })
            .fetch()
        }
      }, 100)
    },
    back () {
      this.$router.push({ name: 'smartForm' })
    },
    leavelHandler (b) {
      const { leave } = this
      if (b) {
        this.status = true
        this.$router.push({ name: leave.name })
      } else {
        this.status = false
      }
      this.$refs.leaveTip.changeLimitDialog(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.main-box {
  overflow: hidden;
}
.form-content::v-deep {
  width: 1278px;
  border: 1px solid #ebebeb;
  background: #fff;
  border-radius: 4px;
  margin: 24px auto 32px;
  .ant-tabs-bar {
    margin-bottom: 0;
  }
  .left-content {
    width: 682px;
    border-right: 1px solid #ebebeb;
    float: left;
    padding: 24px;
  }
  .right-content {
    width: 570px;
    float: right;
    padding: 24px 0 24px 24px;
    position: relative;
    box-sizing: content-box;
  }
  .tab-error-icon {
    color: #f00;
  }
}
.config-form-box::v-deep {
  .ant-form-item {
    display: block;
    margin-bottom: 24px;
  }
}
#iframe {
  text-indent: -9999px;
}
</style>
